export default {
    state: {
        navTree: [],  // 导航菜单树
        activeMenu: '',  // 激活的菜单
    },
    getters: {
   
    },
    mutations: {
        setNavTree(state, navTree){  // 设置导航菜单树
            state.navTree = navTree;
        },
        setActiveMenu(state, activeMenu){  // 设置激活的菜单
            state.activeMenu = activeMenu;
        }
    },
    actions: {
        
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/menu.js